import { render, staticRenderFns } from "./NextAuction.vue?vue&type=template&id=4498b5ed&scoped=true&"
import script from "./NextAuction.vue?vue&type=script&lang=js&"
export * from "./NextAuction.vue?vue&type=script&lang=js&"
import style0 from "./NextAuction.vue?vue&type=style&index=0&id=4498b5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498b5ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})
